<div class="container-ac text-end">
  <!-- <p class="text-start">
    En esta sección podrá visualizar los permisos del usuario seleccionado, y
    editar, en caso de ser necesario.
    <br />
    <small class="text-start">
      Los mismos están distribuidos por LoB, con su título (alcance) y
      descripción.
    </small>
  </p> -->
  <!-- </p> -->
  <button *ngIf="disabled" class="btn btn-primary mb-3" (click)="startEditing()">
    <i class="pi pi-pencil me-2"></i>
    Habilitar edición
  </button>

  <button *ngIf="!disabled" class="btn btn-danger mb-3 mr-3" (click)="cancelAction()">
    <i class="pi pi-times me-2"></i>
    Cancelar
  </button>

  <button *ngIf="!disabled" class="btn btn-primary mb-3" (click)="addPermissions()">
    <i class="pi pi-check me-2"></i>
    Guardar cambios
  </button>
  <p-accordion>
    <p-accordionTab *ngFor="let i of permissionsByLob" [(selected)]="i.selected">
      <ng-template pTemplate="header">
        <!-- Checkbox Principal -->
        <label class="label-ac" [ngClass]="{ dis: disabled }" style="z-index: 100" (click)="
            i.selected = !i.selected; !disabled ? toggleParent(!i.check, i) : ''
          " pTooltip="Debe habilitar el modo edición" [tooltipDisabled]="!disabled" tooltipPosition="top">
          <input type="checkbox" [indeterminate]="i.indeterminate" [(ngModel)]="i.check"
            (ngModelChange)="toggleParent($event, i)" />
          <div class="check-ac" style="background: none"
            *ngIf="!i.indeterminate && !i.check && i.permissions.length != 0"></div>
          <div class="check-ac" *ngIf="i.check && i.permissions.length != 0">
            <i class="pi pi-check"></i>
          </div>
          <div class="check-ac" *ngIf="i.indeterminate && !i.check">
            <i class="pi pi-minus" style="color: white; font-size: 0.6rem; padding: 0; margin: 0"></i>
          </div>
          <p class="m-0">
            <strong>{{ i.lob }}</strong>
            <small class="permission-count">
              {{ i.permissions.length }}
              {{ i.permissions.length === 1 ? 'permiso' : 'permisos' }}
            </small>
          </p>
        </label>
      </ng-template>

      <!-- Recorremos los child -->
      <div *ngFor="let child of i.permissions">
        <label class="label-ac" [ngClass]="{ dis: disabled }" pTooltip="Debe habilitar el modo edición"
          [tooltipDisabled]="!disabled" tooltipPosition="top">
          <input type="checkbox" [(ngModel)]="child.check" (change)="toggleChild(i)" [disabled]="disabled" />
          <div class="check-ac" style="background: none" *ngIf="!child.check"></div>
          <div class="check-ac" *ngIf="child.check">
            <i class="pi pi-check" style="color: white; font-size: 0.8rem; padding: 0; margin: 0"></i>
          </div>
          <p class="m-0">{{ child.title }}</p>
        </label>
        <div style="cursor: default" class="pl-4 mb-2 text-start">
          <small>Descripción: {{ child.description }}</small>
        </div>
        <div style="cursor: default" class="pl-4 pr-4 mb-2">
          <hr />
        </div>
      </div>

      <p class="m-0" *ngIf="i.permissions.length == 0">Nada para mostrar</p>
    </p-accordionTab>
  </p-accordion>
</div>

<app-dialog #dialog />